<template>
  <div class="filters__toolbar">
    <div id="myGroup" class="collapser__container">
      <div class="filters__container">
        <div class="toolbar__title">
          <span>Filtros</span>
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.20701 12.5H18.007M4.80701 7.69995H20.407M10.807 17.3H14.407" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="filters__actions">
          <button class="filter__action" v-on:click="toggle(1)" data-toggle="collapse" href="#collapseLocation" aria-expanded="false" aria-controls="collapseLocation">
            <div class="filter__labels">
              <span class="filter__label">Locación</span>
              <span class="filter__value">{{ locationName }}</span>
            </div>
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#F5FBFF"/>
            </svg>
          </button>
          <button class="filter__action" v-on:click="toggle(2)" data-toggle="collapse" href="#collapsePropertyType" aria-expanded="false" aria-controls="collapsePropertyType">
            <div class="filter__labels">
              <span class="filter__label">Tipo de propiedad</span>
              <span class="filter__value">{{ propertyName }}</span>
            </div>
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#F5FBFF"/>
            </svg>
          </button>
          <button class="filter__action" data-toggle="collapse" href="#collapseCurrentCash" aria-expanded="false" aria-controls="collapseCurrentCash">
            <div class="filter__labels">
              <span class="filter__label filter__label__sm">Retorno Anual Actual</span>
              <span class="filter__value">{{ selectedCash }}%</span>
            </div>
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#F5FBFF"/>
            </svg>
          </button>
          <button class="filter__action" data-toggle="collapse" href="#collapseCurrentProjectIRR" aria-expanded="false" aria-controls="collapseCurrentProjectIRR">
            <div class="filter__labels">
              <span class="filter__label filter__label__sm">TIR Actual Proyectada</span>
              <span class="filter__value">{{ selectedProjected }}%</span>
            </div>
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#F5FBFF"/>
            </svg>
          </button>
          <button class="filter__action" data-toggle="collapse" href="#collapseOrder" aria-expanded="false" aria-controls="collapseOrder">
            <div class="filter__labels">
              <span class="filter__label">Orden</span>
              <span class="filter__value">Todos</span>
            </div>
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.5282 13.6085L19.9059 12.1821L15.6071 15.9615L11.3083 12.1821L9.68594 13.6085L15.6071 18.8179L21.5282 13.6085Z" fill="#F5FBFF"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="collapse filter__content" id="collapseLocation" data-parent="#myGroup">
        <div class="filter__content__heading">
          <span class="filter__heading__title">Selecciona locación</span>
          <div class="filter__input__wrapper">
            <input class="filter__input" type="text" placeholder="Search" />
            <svg class="filter__input__icon" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.4642 22.6598C5.34988 22.6598 0.380859 17.6908 0.380859 11.5765C0.380859 5.46218 5.34988 0.493164 11.4642 0.493164C17.5785 0.493164 22.5475 5.46218 22.5475 11.5765C22.5475 17.6908 17.5785 22.6598 11.4642 22.6598ZM11.4642 4.1876C7.38182 4.1876 4.0753 7.49413 4.0753 11.5765C4.0753 15.6588 7.38182 18.9654 11.4642 18.9654C15.5465 18.9654 18.8531 15.6588 18.8531 11.5765C18.8531 7.49413 15.5465 4.1876 11.4642 4.1876Z" fill="#F5FBFF"/>
              <path d="M22.5475 24.507C22.0672 24.507 21.6054 24.3223 21.236 23.9713L17.5415 20.2769C16.8211 19.5565 16.8211 18.3927 17.5415 17.6723C18.2619 16.9519 19.4257 16.9519 20.1461 17.6723L23.8405 21.3667C24.561 22.0872 24.561 23.2509 23.8405 23.9713C23.4711 24.3408 23.0093 24.507 22.529 24.507H22.5475Z" fill="#F5FBFF"/>
            </svg>
          </div>
        </div>
        <div class="filter__options">
          <button :class="selectedLocation === 0 ? 'filter__option-item active':'filter__option-item'" @click="locationSelect(0, 'All markets')">All markets</button>
          <button :class="selectedLocation === item.id ? 'filter__option-item active':'filter__option-item'" @click="locationSelect(item.id, item.attributes.name)" v-for="(item, index) in locations" :key="index">{{ item.attributes.name }}</button>
        </div>
      </div>
      <div class="collapse filter__content" id="collapsePropertyType" data-parent="#myGroup">
        <div class="filter__content__heading">
          <span class="filter__heading__title">Selecciona tipo de propiedad</span>
        </div>
        <div class="filter__options">
          <button @click="propertyTypeSelect(0, 'Todas')" :class="selectedPropertyType === 0 ? 'filter__option-item active':'filter__option-item'" >All properties</button>
          <button @click="propertyTypeSelect(item.id, item.attributes.name)" v-for="(item, index) in propertyTypes" :key="index" :class="selectedPropertyType === item.id ? 'filter__option-item active':'filter__option-item'" >{{ item.attributes.name }}</button>
        </div>
      </div>
      <div class="collapse filter__content" id="collapseCurrentCash" data-parent="#myGroup">
        <div class="filter__content__heading">
          <span class="filter__heading__title">Retorno Anual Actual</span>
        </div>
        <div class="slider__content">
          <div class="slider__apply">
            <slider v-model="valueCash" />
            <button @click="cashSelect(valueCash)" class="btn__apply">Aplica</button>
          </div>
        </div>
      </div>
      <div class="collapse filter__content" id="collapseCurrentProjectIRR" data-parent="#myGroup">
        <div class="filter__content__heading">
          <span class="filter__heading__title">TIR Actual Proyectada</span>
        </div>
        <div class="slider__content">
          <div class="slider__apply">
            <slider v-model="value" />
            <button @click="projectedSelect(value)" class="btn__apply">Apply</button>
          </div>
        </div>
      </div>
      <div class="collapse filter__content order__list" id="collapseOrder" data-parent="#myGroup">
        <div class="filter__options">
          <button @click="orderSelect(1)" :class="selectedOrder === 1 ? 'filter__option-item_hover' : 'filter__option-item'">Todos</button>
          <button @click="orderSelect(2)" :class="selectedOrder === 2 ? 'filter__option-item_hover' : 'filter__option-item'">Nuevos</button>
          <button @click="orderSelect(3)" :class="selectedOrder === 3 ? 'filter__option-item_hover' : 'filter__option-item'">Próximos</button>
        </div>
      </div>
    </div>
    <div class="list__actions">
      <button
        class="action"
        :class="{'active': viewStyle === 'grid'}"
        @click="changeViewStyle('grid')"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.55374 8.36352H3.12374C1.86374 8.36352 0.83374 7.33352 0.83374 6.07352V2.64352C0.83374 1.38352 1.86374 0.353516 3.12374 0.353516H6.55374C7.81374 0.353516 8.84374 1.38352 8.84374 2.64352V6.07352C8.84374 7.33352 7.81374 8.36352 6.55374 8.36352ZM3.12374 2.36352C2.96374 2.36352 2.83374 2.49352 2.83374 2.65352V6.08352C2.83374 6.23352 2.96374 6.37352 3.12374 6.37352H6.55374C6.71374 6.37352 6.84374 6.24352 6.84374 6.08352V2.65352C6.84374 2.50352 6.71374 2.36352 6.55374 2.36352H3.12374Z" fill="currentColor"/>
          <path d="M15.5537 8.36352H12.1237C10.8637 8.36352 9.83374 7.33352 9.83374 6.07352V2.64352C9.83374 1.38352 10.8637 0.353516 12.1237 0.353516H15.5537C16.8137 0.353516 17.8437 1.38352 17.8437 2.64352V6.07352C17.8437 7.33352 16.8137 8.36352 15.5537 8.36352ZM12.1237 2.36352C11.9637 2.36352 11.8337 2.49352 11.8337 2.65352V6.08352C11.8337 6.23352 11.9637 6.37352 12.1237 6.37352H15.5537C15.7137 6.37352 15.8437 6.24352 15.8437 6.08352V2.65352C15.8437 2.50352 15.7137 2.36352 15.5537 2.36352H12.1237Z" fill="currentColor"/>
          <path d="M6.55374 17.3635H3.12374C1.86374 17.3635 0.83374 16.3335 0.83374 15.0735V11.6435C0.83374 10.3835 1.86374 9.35352 3.12374 9.35352H6.55374C7.81374 9.35352 8.84374 10.3835 8.84374 11.6435V15.0735C8.84374 16.3335 7.81374 17.3635 6.55374 17.3635ZM3.12374 11.3635C2.96374 11.3635 2.83374 11.4935 2.83374 11.6535V15.0835C2.83374 15.2335 2.96374 15.3735 3.12374 15.3735H6.55374C6.71374 15.3735 6.84374 15.2435 6.84374 15.0835V11.6535C6.84374 11.5035 6.71374 11.3635 6.55374 11.3635H3.12374Z" fill="currentColor"/>
          <path d="M15.5537 17.3635H12.1237C10.8637 17.3635 9.83374 16.3335 9.83374 15.0735V11.6435C9.83374 10.3835 10.8637 9.35352 12.1237 9.35352H15.5537C16.8137 9.35352 17.8437 10.3835 17.8437 11.6435V15.0735C17.8437 16.3335 16.8137 17.3635 15.5537 17.3635ZM12.1237 11.3635C11.9637 11.3635 11.8337 11.4935 11.8337 11.6535V15.0835C11.8337 15.2335 11.9637 15.3735 12.1237 15.3735H15.5537C15.7137 15.3735 15.8437 15.2435 15.8437 15.0835V11.6535C15.8437 11.5035 15.7137 11.3635 15.5537 11.3635H12.1237Z" fill="currentColor"/>
        </svg>
      </button>
      <button
        class="action"
        :class="{'active': viewStyle === 'list'}"
        @click="changeViewStyle('list')"
      >
        <svg width="18" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5537 8.36352H3.13375C1.87375 8.36352 0.84375 7.33352 0.84375 6.07352V2.64352C0.84375 1.38352 1.87375 0.353516 3.13375 0.353516H14.5637C15.8237 0.353516 16.8538 1.38352 16.8538 2.64352V6.07352C16.8538 7.33352 15.8237 8.36352 14.5637 8.36352H14.5537ZM3.12375 2.36352C2.96375 2.36352 2.83375 2.49352 2.83375 2.65352V6.08352C2.83375 6.23352 2.96375 6.37352 3.12375 6.37352H14.5537C14.7137 6.37352 14.8438 6.24352 14.8438 6.08352V2.65352C14.8438 2.50352 14.7137 2.36352 14.5537 2.36352H3.13375H3.12375Z" fill="#3A2E85"/>
          <path d="M14.5537 17.3635H3.13375C1.87375 17.3635 0.84375 16.3335 0.84375 15.0735V11.6435C0.84375 10.3835 1.87375 9.35352 3.13375 9.35352H14.5637C15.8237 9.35352 16.8538 10.3835 16.8538 11.6435V15.0735C16.8538 16.3335 15.8237 17.3635 14.5637 17.3635H14.5537ZM3.12375 11.3635C2.96375 11.3635 2.83375 11.4935 2.83375 11.6535V15.0835C2.83375 15.2335 2.96375 15.3735 3.12375 15.3735H14.5537C14.7137 15.3735 14.8438 15.2435 14.8438 15.0835V11.6535C14.8438 11.5035 14.7137 11.3635 14.5537 11.3635H3.13375H3.12375Z" fill="#3A2E85"/>
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue';
export default {
  name: 'FiltersToolbar',
  props: {
    locations: {
      type: Array,
      required: true,
      default:{}
    },
    propertyTypes: {
      type: Array,
      required: true,
      default:{}
    },
    CoC: {
      type: Array,
      required: true,
      default:{}
    },
    IRR: {
      type: Array,
      required: true,
      default:{}
    },
  },
  data() {
    return {
      showSection1: false,
      showSection2: false,
      showSection3: false,
      showSection4: false,
      showSection5: false,
      selectedOrder:0,
      selectedCash:0,
      selectedProjected:0,
      locationName:"Todas",
      propertyName:"Todas",
      valueCash:0,
      value: 0,
      viewStyle: 'grid',
      selectedLocation:0,
      selectedPropertyType:0,
    };
  },
  created () {
    
  },
  methods: {
    toggle(option) {
      console.log(option)
      if (option === 1) {
        
        
      }

      if (option === 2) {
       
      }
     
    },
    locationSelect(item, name) {
      console.log("item",item)
      this.selectedLocation = item
      this.locationName = name
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType)
    },
    propertyTypeSelect(item, name){
      console.log(item)
      this.propertyName = name
      this.selectedPropertyType = item
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType)
    },
    projectedSelect(item){
      console.log(item)
      this.selectedProjected = item
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType, this.selectedProjected, this.selectedCash)
    },
    orderSelect(item){
      console.log(item)
      this.selectedOrder = item
      //this.$emit('on-change', this.selectedLocation, this.selectedPropertyType)
    },
    cashSelect(item){
      console.log(item)
      this.selectedCash = item
      this.$emit('on-change', this.selectedLocation, this.selectedPropertyType, this.selectedProjected, this.selectedCash)
    },
    changeViewStyle(style) {
      this.viewStyle = style;
      this.$emit('change-view', style);
    },
  },
  components: {
    Slider,
  },
}
</script>
<style lang="scss">
.filters__actions {
  display: flex;
  flex: 1;
}

.filter__action {
  all: unset;
  display: flex;
  gap: 8px;
  align-items: center;
  border-left: 1px solid #F5FBFF;
  border-right: 1px solid #F5FBFF;
  padding: 0 16px;

  &:first-child {
    border-left: 0;
  }

  &:last-child {
    border-right: 0;
  }

  .filter__labels {
    display: flex;
    flex-direction: column;

    .filter__label {
      font-family: 'Montserrat', sans-serif;
      font-size: 16px;
      line-height: 16px;
      color: white;

      &.filter__label__sm {
        font-size: 12px;
        line-height: 16px;
      }
    };
    .filter__value {
      font-family: 'Roboto', sans-serif;
      font-size: 12px;
      line-height: 18px;
      color: #9AEEC5;
    }
  }
}

.collapser__container {
  position: relative;
  display: flex;
}

.filters__toolbar {
  display: none;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  position: relative;

  .toolbar__title {
    color: white;
    display: flex;
    align-items: center;
    gap: 8px;
    span {
      font-size: 20px;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      color: white;
    }
  }

  .filters__container {
    flex: 1;
    display: flex;
    gap: 24px;
    padding: 16px;
    min-height: 40px;
    background-color: #351467;
    border: 1px solid #3A2E8510;
    border-radius: 4px;
    box-shadow: 0 0 0 7px rgba(58, 46, 133, 0.1);
  }

  .list__actions {
    display: flex;
    flex-direction: row;
    gap: 0;
    border: 1px solid white;
    overflow: hidden;
    border-radius: 9999px;
    flex-shrink: 0;

    .action {
      all: unset;
      cursor: pointer;
      padding: 8px 12px;
      background-color: white;
      display: flex; 
      justify-content: center;
      align-items: center;
      &.active {
        background-color: #9AEEC5;
      }
    }
  }
}

.filter__content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  margin-top: 76px;
  background: rgba(18, 4, 39, 1);
  padding: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .filter__content__heading {
    display: flex;
    justify-content: space-between;
    .filter__heading__title {
      font-size: 16px;
      line-height: 16px;
      font-family: 'Montserrat', sans-serif;
      color: white;
    }
    .filter__input__wrapper {
      background: rgba(255, 255, 255, 0.1);
      padding: 12px 20px;
      min-width: 320px;
      display: flex;
      gap: 12px;
      justify-content: space-between;
      .filter__input {
        color: white;
        background: transparent;
        border: 0;
        outline: 0 none;
      }
      .filter__input__icon {}
    }
  }
}

.filter__options {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
  .filter__option-item {
    border: 1px solid #D6FFFF;
    padding: 8px 12px;
    border-radius: 9999px;
    background-color: transparent;
    color: #D6FFFF;
    font-size: 14px;
    line-height: 20px;
    &.active {
      background-color: #D6FFFF;
      color: #00125A;
    }
    &:hover{
      background-color: #D6FFFF;
      color: #00125A;
    }
  }
    .filter__option-item_hover {
      background-color: #D6FFFF;
      color: #00125A;
      padding: 8px 12px;
      border-radius: 9999px;
      font-size: 14px;
      line-height: 20px;
    }
}

.slider {
  padding: 10px 0;
}

.slider__content {
  display: flex;
  justify-content: center;
}

.slider__apply {
  max-width: 720px;
  display: flex;
  align-items: center;
  gap: 56px;
}

.btn__apply {
  border: 0;
  border-radius: 9999px;
  outline: 0 none;
  background: white;
  padding: 8px 24px;
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
}

.order__list {
  max-width: 280px;
  left: unset;
  right: 0;
  .filter__options {
    flex-direction: column;
    gap: 4;
  }
}

@media (min-width: 992px) {
  .filters__toolbar {
    display: flex;
  }
}
</style>